<div class="frameContent" id="desc">
  <div class="frameBigText">
    <p>
      <span class="frameHighlight">{{
        headerHighlight() || "Oops, something went wrong" | translate
      }}</span>
      <br />
      {{ header() || "Oops, something went wrong" | translate }}
    </p>
  </div>
  <div class="desc">
    <p>
      <span class="descHeader">
        {{ descHeader() || "Oops, something went wrong" | translate }}</span
      >
    </p>
    @if (logo1()?.src) {
    <p>{{ descText1() || "Oops, something went wrong" | translate }}</p>
    <div class="logos">
      <a [href]="logo1()?.link" target="_blank" class="logo">
        <img class="logoImg" [src]="logo1()?.src" [alt]="logo1()?.alt"
      /></a>
      @if (logo2()?.src) {
      <a [href]="logo2()?.link" target="_blank" class="logo">
        <img class="logoImg" [src]="logo2()?.src" [alt]="logo2()?.alt" /></a
      >} @if (logo3()?.src){
      <a [href]="logo3()?.link" target="_blank" class logo>
        <img class="logoImg" [src]="logo3()?.src" [alt]="logo3()?.alt" /></a
      >}
    </div>
    } @if (logo4()?.src) {
    <p>{{ descText2() || "Oops, something went wrong" | translate }}</p>
    }
    <div class="logos">
      @if (logo4()?.src) {
      <a [href]="logo4()?.link" target="_blank" class="logo">
        <img class="logoImg" [src]="logo4()?.src" [alt]="logo4()?.alt" /></a
      >} @if (logo5()?.src) {
      <a [href]="logo5()?.link" target="_blank" class="logo">
        <img class="logoImg" [src]="logo5()?.src" [alt]="logo5()?.alt" /></a
      >}
    </div>
  </div>
</div>
